var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('s-g-nav'),_c('div',{staticClass:"detail__content"},[_c('s-g-colors')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }